import { Modal } from 'antd'
import styled from 'styled-components'

export const CombineModalStyled = styled(Modal)`
  padding: 12px;
  background-color: rgba(0,0,0,.03);
`
